import { calculateCisDeductionInvoice } from 'pages/requestForm/selectors/xero/cisDeductionUtils';
import { FC, memo } from 'react';

import { XeroCisDeductionLine } from '../index';
import { XeroCisDeductionInvoiceProps } from './XeroCisDeductionInvoice.types';

/**
 * @deprecated Old design
 */
const XeroCisDeductionInvoice: FC<XeroCisDeductionInvoiceProps> = memo((props) => {
    const { cisRate, lineAmountType, lineItems, currency } = props;

    const cisTaxAmount = calculateCisDeductionInvoice(lineItems, cisRate, lineAmountType);

    if (typeof cisTaxAmount !== 'number') {
        return null;
    }

    return <XeroCisDeductionLine cisRate={cisRate} cisTaxAmount={cisTaxAmount} currency={currency} />;
});

export default XeroCisDeductionInvoice;
